import { isEmpty } from 'lodash';
import type { FinderItem } from '@frameio/graphql-client';
import type { DeepPartial } from '@frameio/utils';
import type { IMediaThumbnail } from '@frameio/vapor';
import { getMediaTranscodesByKey } from './getMediaTranscodesByKey';

/**
 * Returns props for MediaThumbnail
 */
export const getThumbMedia = (
  item: DeepPartial<FinderItem>,
  options?: {
    width?: number;
    height?: number;
  }
): IMediaThumbnail | null => {
  const transcodes =
    item &&
    'thumbTranscodes' in item &&
    item.thumbTranscodes &&
    getMediaTranscodesByKey(item.thumbTranscodes);

  const media: IMediaThumbnail = {};

  if (isEmpty(item)) {
    return null;
  }

  if ('media' in item && item.media && 'metadata' in item.media) {
    media.metadata = item.media.metadata ?? undefined;
  }

  // legacy thumbnail
  if (transcodes && transcodes.thumb) {
    media.thumbs = media.thumbs || {};
    media.thumbs.thumb = transcodes.thumb.streamUrl ?? undefined;
  }

  // legacy thumbnail
  if (transcodes && transcodes.thumb540) {
    media.thumbs = media.thumbs || {};
    media.thumbs.thumb540 = transcodes.thumb540.streamUrl ?? undefined;
  }

  // legacy thumbnail
  if (transcodes && transcodes.thumbOrigAr540) {
    media.thumbs = media.thumbs || {};
    media.thumbs.thumbOrigAr540 =
      transcodes.thumbOrigAr540.streamUrl ?? undefined;
  }

  // picture2 thumbnail
  if ('thumbnailImageUrl' in item && item.thumbnailImageUrl) {
    media.thumbs = media.thumbs || {};
    media.thumbs.thumb2 = `${item.thumbnailImageUrl?.url}${
      options?.height ? `&height=${options.height}` : ''
    }${options?.width ? `&width=${options.width}` : ''}`;
  }

  if (
    'media' in item &&
    item.media &&
    'thumbScrubSprite' in item.media &&
    item.media.thumbScrubSprite
  ) {
    media.thumbs = media.thumbs || {};
    media.thumbs.thumbScrub =
      item.media.thumbScrubSprite.streamUrl ?? undefined;
    media.thumbs.thumbScrubFrameCount =
      item.media.thumbScrubSprite.frames ?? undefined;
    media.thumbs.thumbScrubTileX =
      item.media.thumbScrubSprite.tileX ?? undefined;
    media.thumbs.thumbScrubTileY =
      item.media.thumbScrubSprite.tileY ?? undefined;
  }

  return media;
};
